// Exact Figma export (Lucide, 2px stroke on a 11px grid). Stroke colour is a prop.
function PaywallCheck({ dimensions, col = '#fff' }) {
  return `
    <svg width=${dimensions || '11'} height=${dimensions || '11'} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.1663 2.75L4.12514 7.7913L1.8337 5.4998" stroke="${col}" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `;
}

export default PaywallCheck;
